import { Search, RefreshCw, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface SearchHeaderProps {
  value: string;
  onChange: (v: string) => void;
  onRefresh: () => void;
  isRefreshing: boolean;
}

export function SearchHeader({ value, onChange, onRefresh, isRefreshing }: SearchHeaderProps) {
  return (
    <div className="flex items-center gap-3 px-4 py-2.5">
      <div className="flex-1 relative">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Search posts..."
          className="w-full pl-9 pr-8 py-2 text-sm bg-muted rounded-full border-0 focus:ring-2 focus:ring-primary/20 focus:outline-none placeholder:text-muted-foreground/60"
        />
        {value && (
          <button
            onClick={() => onChange("")}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground"
          >
            <X className="w-3.5 h-3.5" />
          </button>
        )}
      </div>

      <Button
        onClick={onRefresh}
        disabled={isRefreshing}
        size="icon"
        variant="ghost"
        className="w-9 h-9 shrink-0"
      >
        <RefreshCw className={cn("h-4 w-4", isRefreshing && "animate-spin")} />
      </Button>
    </div>
  );
}
